<template>
    <div class="indexaPage">
        <div class="menubox">
            <div class="menus"> 
                <div idx="3" class="item" @click="menuClick(3)">售价</div>
                <div idx="1" class="item" @click="menuClick(1)">极致性能</div>
                <div idx="2" class="item" @click="menuClick(2)">动感设计</div>
                <div idx="4" class="item" @click="menuClick(4)">掠影</div>
            </div>
            <div class="btn-yuyue" @click="menuClick(6)">预约试驾</div>
        </div>

        <div class="page page0">
            <div class="topbox">
                <div class="cullcon">
                    <div class="bg"></div>
                    <div class="con">
                        <div class="logo"></div>
                        <div class="texts">生于赛场，暗藏锋芒</div>
                    </div>
                    <div class="mask"></div>
                    <div class="num_a">0</div>
                    <div class="num_b">1</div>
                    <div class="num_text">
                        <div class="txt0">全球限量 <span class="en">20</span> 台</div>
                        <div class="txt1">以极致性能与暗夜美学<br />致敬 <span class="en">quattro 45</span> 载传奇</div>
                    </div>
                </div>
            </div>
            <div class="bottombox">
                <div class="cullcon">
                    <div class="bg"></div>
                    <div class="con">
                        <div class="logo"></div>
                        <div class="texts">生于赛场，暗藏锋芒</div>
                    </div>
                    <div class="mask"></div>
                    <div class="num_a">0</div>
                    <div class="num_b">1</div>
                    <div class="num_text">
                        <div class="txt0">全球限量 <span class="en">20</span> 台</div>
                        <div class="txt1">以极致性能与暗夜美学<br />致敬 <span class="en">quattro 45</span> 载传奇</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="page page3">
            <div class="bg"></div>
            <div class="price-box">
                <div class="price">1,724,800</div>
                <div class="texts">
                    <div class="txt0">市场指导价</div>
                    <div class="txt1">RMB</div>
                </div>
            </div>
        </div>
        <div class="page page6">
            <div class="bg"></div>
            <div class="yuyue-box">
                <Yuyue0 v-if="dealer " :cartype="165280"></Yuyue0>
                <Yuyue1 v-else :cartype="165280"></Yuyue1>
            </div>
        </div>
        <div class="page page1">
            <div class="bg"></div>
            <div class="slotbox">
                <div class="slot slot0">
                    <div class="number">01</div>
                    <div class="txt">巅峰性能</div>
                    <div class="arrow" @click="showPage1Swiper(0)"></div>
                </div>
                <div class="slot slot1">
                    <div class="number">02</div>
                    <div class="txt">巅峰操控</div>
                    <div class="arrow" @click="showPage1Swiper(1)"></div>
                </div>
                <div class="slot slot2">
                    <div class="number">03</div>
                    <div class="txt">巅峰制动</div>
                    <div class="arrow" @click="showPage1Swiper(2)"></div>
                </div>
            </div>
        </div>
        <div class="page page2">
            <div class="bg"></div>
            <div class="slotbox">
                <div class="slot slot0">
                    <div class="number">01</div>
                    <div class="txt">专属的<span class="en">RS</span>风格<br />和运动气息</div>
                    <div class="arrow" @click="showPage2Swiper(0)"></div>
                </div>
                <div class="slot slot1">
                    <div class="number">02</div>
                    <div class="txt">巅峰黑科技</div>
                    <div class="arrow" @click="showPage2Swiper(1)"></div>
                </div>
                <div class="slot slot2">
                    <div class="number">03</div>
                    <div class="txt">限量珍藏<br />的专属内饰</div>
                    <div class="arrow" @click="showPage2Swiper(2)"></div>
                </div>
            </div>
        </div>

        <div class="page page4">
            <div class="image-grid">
                <div class="cell cell-0">
                    <div class="img0box">
                        <img src="../assets/indexa/page4_img0.jpg" idx="0" />
                    </div>
                    <div class="img1box">
                        <img src="../assets/indexa/page4_img1.jpg" idx="7" />
                    </div>
                </div>
                <div class="cell cell-1">
                    <div class="row0">
                        <div class="img0box">
                            <img src="../assets/indexa/page4_img2.jpg" idx="1" />
                        </div>
                        <div class="img1box">
                            <img src="../assets/indexa/page4_img3.jpg" idx="2" />
                        </div>
                    </div>
                    <div class="row1">
                        <div class="img0box">
                            <img src="../assets/indexa/page4_img0.jpg" idx="-1" />
                        </div>
                    </div>
                    <div class="row2">
                        <div class="img0box">
                            <img src="../assets/indexa/page4_img4.jpg" idx="6" />
                        </div>
                        <div class="img1box">
                            <img src="../assets/indexa/page4_img5.jpg" idx="5" />
                        </div>
                    </div>
                </div>
                <div class="cell cell-2">
                    <div class="img0box">
                        <img src="../assets/indexa/page4_img6.jpg" idx="3" />
                    </div>
                    <div class="row1">
                        <div class="img1box">
                            <img src="../assets/indexa/page4_img7.jpg" idx="4" />
                        </div>
                        <div class="btn-next">
                            <span>下一个</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="page page5">
            <div class="content-0">
                <div class="bg"></div>
                <div class="con">
                    <div class="logo"></div>
                    <div class="line"></div>
                    <div class="h2">
                        <span>生于赛场，暗藏锋芒</span>
                        <div class="after" @click="toGt()"></div>
                    </div>
                    <div class="h5"></div>
                </div>
            </div>
            <div class="content-1">
                <div class="con">
                    <div class="logo"></div>
                    <div class="txt">一汽奥迪 <span class="enb">RS</span> 旗舰双车限量登场<br />尽在奥迪</div>
                </div>
            </div>
        </div>

        <div class="swiperbox swiper_page1_slot swiper_page1_slot0" style="display: none">
            <div class="swiper mySwiper">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="imgbox">
                            <img class="img" src="../assets/indexa/page1_slot0_0.jpg" />
                            <div class="textbox0">
                                <div class="h3">巅峰动力 一呼即应</div>
                                <div class="desc"><span class="en">4.0L</span> 双涡轮增压 <span class="en">V8</span> 引擎搭配 <span class="en">48V</span> 微混系统，爆发出 <span class="en">471kW</span><br />最大功率与 <span class="en">850N·m</span> 峰值扭矩，<span class="en">3.6</span> 秒破百。近乎零延迟的响<br />应，诠释极致加速体验。</div>
                            </div>
                        </div>
                        <div class="close" @click="hidePage1Swiper(0)"></div>
                    </div>
                    <div class="swiper-slide">
                        <div class="imgbox">
                            <img class="img" src="../assets/indexa/page1_slot0_1.jpg" />
                            <div class="textbox0">
                                <div class="h3">极致驾驭 人车合一</div>
                                <div class="desc">
                                    <span class="en">8</span> 速 <span class="en">Tiptronic</span> 变速箱以毫秒级换挡，实现动力无中断衔接<br />搭配机械式 <span class="en">quattro</span> 全时四驱，支持前/后桥 <span class="en">70:30</span> 至<br />
                                    <span class="en">15:85</span> 动态扭矩分配，运动差速器加持，后桥左右轮扭矩<br />分配达 <span class="en">1800N·m</span>，疾驰弯道，如履平地
                                </div>
                            </div>
                        </div>
                        <div class="close" @click="hidePage1Swiper(0)"></div>
                    </div>
                </div>
                <div class="swiper-pagination pagination-type-0"></div>
            </div>
        </div>

        <div class="swiperbox swiper_page1_slot swiper_page1_slot1" style="display: none">
            <div class="swiper mySwiper">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="imgbox">
                            <img class="img" src="../assets/indexa/page1_slot1_0.jpg" />
                            <div class="textbox0 textbox1">
                                <div class="h3">灵动底盘 征服全域</div>
                                <div class="desc">自适应空气悬挂与行业首创主动侧倾稳定系统，毫秒级调整车身姿态<br />全轮转向技术，高速沉稳，低速灵活，全路况尽在掌控</div>
                            </div>
                        </div>
                        <div class="close close1" @click="hidePage1Swiper(1)"></div>
                    </div>
                </div>
                <div class="swiper-pagination pagination-type-0"></div>
            </div>
        </div>

        <div class="swiperbox swiper_page1_slot swiper_page1_slot2" style="display: none">
            <div class="swiper mySwiper">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="imgbox">
                            <img class="img" src="../assets/indexa/page1_slot2_0.jpg" />
                            <div class="textbox0 textbox2">
                                <div class="h3"><span class="en">10</span> 活塞红色刹车卡钳</div>
                                <div class="desc">同级罕有 <span class="en">10</span> 活塞红色卡钳，有效增加制动接触面积<br />制动力均匀强劲</div>
                            </div>
                        </div>
                        <div class="close close2" @click="hidePage1Swiper(2)"></div>
                    </div>
                    <div class="swiper-slide">
                        <div class="imgbox">
                            <img class="img" src="../assets/indexa/page1_slot2_1.jpg" />
                            <div class="textbox0 textbox2">
                                <div class="h3"><span class="en">440mm</span> 碳陶制动盘</div>
                                <div class="desc">奥迪品牌有史以来所采用的技术最硬核、性能最佳、尺寸最大<br />的刹车盘，搭配赛用级超宽轮胎，抓地力与制动效率媲美超跑</div>
                            </div>
                        </div>
                        <div class="close close2" @click="hidePage1Swiper(2)"></div>
                    </div>
                </div>
                <div class="swiper-pagination pagination-type-0"></div>
            </div>
        </div>

        <div class="swiperbox swiper_page2_slot swiper_page2_slot0" style="display: none">
            <div class="swiper mySwiper">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="imgbox">
                            <img class="img" src="../assets/indexa/page2_slot0_0.jpg" />
                            <div class="textbox0">
                                <div class="h3">八边形进气格栅</div>
                                <div class="desc">全新蜂窝网状单框架格栅，搭配车身同色 <span class="en">RS</span> 运动前杠<br />进攻性视觉冲击感拉满。保险杠两侧导流槽优化空气<br />动力学，致敬赛道基因</div>
                            </div>
                        </div>
                        <div class="close" @click="hidePage2Swiper(0)"></div>
                    </div>
                    <div class="swiper-slide">
                        <div class="imgbox">
                            <img class="img" src="../assets/indexa/page2_slot0_1.jpg" />
                            <div class="textbox0">
                                <div class="h3"><span class="en">RS</span> 专属排气系统</div>
                                <div class="desc">车身同色运动保险杠与 <span class="en">RS</span> 专属排气系统，澎湃声浪，<br />野性觉醒，锋芒随转速攀升层层释放</div>
                            </div>
                        </div>
                        <div class="close" @click="hidePage2Swiper(0)"></div>
                    </div>
                    <div class="swiper-slide">
                        <div class="imgbox">
                            <img class="img" src="../assets/indexa/page2_slot0_2.jpg" />
                            <div class="textbox0">
                                <div class="h3"><span class="en">45</span> 周年激光铭刻</div>
                                <div class="desc">后门车窗精密镌刻 <span class="en">“45 years of quattro”</span> 专属标识<br />细节处彰显限量身份，尊贵无需张扬</div>
                            </div>
                        </div>
                        <div class="close" @click="hidePage2Swiper(0)"></div>
                    </div>
                </div>
                <div class="swiper-pagination pagination-type-0"></div>
            </div>
        </div>

        <div class="swiperbox swiper_page2_slot swiper_page2_slot1" style="display: none">
            <div class="swiper mySwiper">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="imgbox">
                            <img class="img" src="../assets/indexa/page2_slot1_0.jpg" />
                            <div class="textbox0">
                                <div class="h3">高清矩阵式 <span class="en">LED</span> 大灯</div>
                                <div class="desc">高清矩阵式 <span class="en">LED</span> 大灯搭配激光大灯系统，照射距离极致拓<br />展，智能光束避让，暗夜疾驰，视野如破晓之光，安全与<br />锋芒并存</div>
                            </div>
                        </div>
                        <div class="close" @click="hidePage2Swiper(1)"></div>
                    </div>
                    <div class="swiper-slide">
                        <div class="imgbox">
                            <img class="img" src="../assets/indexa/page2_slot1_1.jpg" />
                            <div class="textbox0">
                                <div class="h3">数字 <span class="en">OLED</span> 尾灯</div>
                                <div class="desc">高清多动画效果数字 <span class="en">OLED</span> 后尾灯，搭载 <span class="en">5</span> 种动态灯<br />光签名，<span class="en">OLED</span> 单元智能控制，明暗渐变如呼吸，昼夜<br />皆成焦点</div>
                            </div>
                        </div>
                        <div class="close" @click="hidePage2Swiper(1)"></div>
                    </div>
                </div>
                <div class="swiper-pagination pagination-type-0"></div>
            </div>
        </div>

        <div class="swiperbox swiper_page2_slot swiper_page2_slot2" style="display: none">
            <div class="swiper mySwiper">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="imgbox">
                            <img class="img" src="../assets/indexa/page2_slot2_0.jpg" />
                            <div class="textbox0 textbox2">
                                <div class="h3">订制超级运动座椅</div>
                                <div class="desc">奥迪专享个性化订制华格纳真皮超级运动座椅，两种专属内饰颜<br />色搭配可选，<span class="en">RS</span> 徽标缝线，匠心定制，限量专属，天生不凡</div>
                            </div>
                        </div>
                        <div class="close close2" @click="hidePage2Swiper(2)"></div>
                    </div>
                    <div class="swiper-slide">
                        <div class="imgbox">
                            <img class="img" src="../assets/indexa/page2_slot2_1.jpg" />
                            <div class="textbox0 textbox1">
                                <div class="h3"><span class="en">Bang & Olufsen 3D</span><br />环绕顶级音响</div>
                                <div class="desc"><span class="en">23</span> 扬声器 <span class="en">3D</span> 环绕系统，<span class="en">1920</span> 瓦功率精准驱动<br />多重强化隔音配合主动降噪，还原音乐厅级临场<br />感，疾驰中亦可聆听天籁共振</div>
                            </div>
                        </div>
                        <div class="close close1" @click="hidePage2Swiper(2)"></div>
                    </div>
                    <div class="swiper-slide">
                        <div class="imgbox">
                            <img class="img" src="../assets/indexa/page2_slot2_2.jpg" />
                            <div class="textbox0 textbox1">
                                <div class="h3">华格纳顶级真皮内饰包</div>
                                <div class="desc">甄选顶级材质，高奢匠心工艺，细腻触感渗透每处细节<br />诠释奥迪专享定制美学</div>
                            </div>
                        </div>
                        <div class="close close1" @click="hidePage2Swiper(2)"></div>
                    </div>
                    <div class="swiper-slide">
                        <div class="imgbox">
                            <img class="img" src="../assets/indexa/page2_slot2_3.jpg" />
                            <div class="textbox0 textbox1">
                                <div class="h3">碳纤维内饰条</div>
                                <div class="desc">赛道精神极致演绎，碳纤维<span class="en">3D</span>立体编织纹理，哑光质感与金属<br />包边碰撞，锋芒藏于细节，诠释性能与工艺的终极平衡</div>
                            </div>
                        </div>
                        <div class="close close1" @click="hidePage2Swiper(2)"></div>
                    </div>
                </div>
                <div class="swiper-pagination pagination-type-0"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { sleep, isWeiXin, isIos, getQueryString, isPhoneNumber, calcSize } from '../utils/index'
import Yuyue0 from './components/yuyue_0.vue'
import Yuyue1 from './components/yuyue_1.vue'

export default {
    components: { Yuyue0, Yuyue1 },
    data() {
        return {
            dealer: '',
            activity: ''
        }
    },
    created() {
        this.dealer = getQueryString('dealer') 
        this.activity = getQueryString('activity')  
    },
    mounted() {
        this.isDestroy = false
        var that = this
        this.canWheel = true
        this.currStep = 0
        this.prevPageIndex = 0
        this.bindMouseWheel()
        that.bindEvents()
    },
    beforeDestroy() {
        this.isDestroy = true
        $(document).off('mousewheel DOMMouseScroll')
        TweenMax.killTweensOf('*')
        console.log('清除动画')
    },
    destroyed() {},
    methods: {
        bindMouseWheel() {
            var that = this
            $(document).on('mousewheel DOMMouseScroll', function (event) {
                if(!that.canWheel) return;
                var delta
                if (event.originalEvent.wheelDelta) {
                    delta = event.originalEvent.wheelDelta
                } else if (event.originalEvent.detail) {
                    delta = -event.originalEvent.detail
                }
                console.log(delta)
                // delta大于0代表向上滚动，delta小于0代表向下滚动
                if (delta > 0) {
                    if (that.currStep == 5) {
                        that.currStep = 4
                        that.changePage(0)
                    } else if (that.currStep == 7) {
                        that.currStep = 6
                        that.changePage(3)
                    } else if (that.currStep == 9) {
                        that.currStep = 8
                        that.changePage(6)
                    } else if (that.currStep == 11) {
                        that.currStep = 10
                        that.changePage(1)
                    } else if (that.currStep == 13) {
                        that.currStep = 10
                        that.changePage(2)
                    } else if (that.currStep == 14) {
                        that.currStep = 12
                        that.changePage(4)
                    }
                } else if (delta < 0) {
                    if (that.currStep == 1) {
                        that.currStep = 2
                        that.bindPage0Next()
                    } else if (that.currStep == 3) {
                        that.currStep = 4
                        that.bindPage0Next2()
                    } else if (that.currStep == 5) {
                        that.currStep = 6
                        that.changePage(6)
                    } else if (that.currStep == 7) {
                        that.currStep = 8
                        that.changePage(1)
                    } else if (that.currStep == 9) {
                        that.currStep = 10
                        that.changePage(2)
                    } else if (that.currStep == 11) {
                        that.currStep = 12
                        that.changePage(4)
                    } else if (that.currStep == 13) {
                        that.currStep = 14
                        that.changePage(5)
                    }
                }
            })
        },
        bindEvents() {
            $(window).scrollTop(0)
            var that = this
            setTimeout(() => {
                that.resetMenu()
                that.resetPage0()
                that.resetPage1()
                that.resetPage2()
                that.resetPage3()
                that.resetPage4()
                that.resetPage5()
                that.bindPage0()
                that.bindPage4Event()
                that.bindSwiper()
            }, 500)
        },
        resetMenu() {
            TweenMax.set('.menubox', { y: calcSize(-110) })
        },
        outMenu() {
            TweenMax.to('.menubox', 0.5, { y: calcSize(-110) })
        },
        inMenu(idx) {
            $('.menubox .item').removeClass('active')
            $('.menubox .item').each(function(i,el){
                var pidx = $(el).attr("idx");
                if(pidx == idx){
                    $(el).addClass("active");
                }
            }) 
            TweenMax.killTweensOf('.menubox');
            TweenMax.to('.menubox', 0.5, { y: calcSize(0) })
        },
        resetPage0() {
            TweenMax.set('.page0 .logo', { opacity: 0, y: 100, x: 0 })
            TweenMax.set('.page0 .texts', { opacity: 0, y: 100, x: 0 })
            TweenMax.set('.page0 .num_a', { opacity: 0 })
            TweenMax.set('.page0 .num_b', { opacity: 0, num: 1 })
            TweenMax.set('.page0 .num_text', { opacity: 0, x: 100 })
            TweenMax.set('.page0 .topbox', { top: '0vh' })
            TweenMax.set('.page0 .bottombox', { top: '50vh' })
        },
        outPage0() {
            TweenMax.to('.page0 .logo', 0.5, { opacity: 0, y: 100, x: 0 })
            TweenMax.to('.page0 .texts', 0.5, { opacity: 0, y: 100, x: 0 })
            TweenMax.to('.page0 .num_a', 0.5, { opacity: 0 })
            TweenMax.to('.page0 .num_b', 0.5, { opacity: 0, num: 1 })
            TweenMax.to('.page0 .num_text', 0.5, { opacity: 0, x: 100 })
            TweenMax.to('.page0 .topbox', 0.5, { top: '0vh' })
            TweenMax.to('.page0 .bottombox', 0.5, { top: '50vh' })
        },
        resetPage1() {
            TweenMax.set('.page1 .slot', { opacity: 0 })
        },
        outPage1() {
            TweenMax.to('.page1 .slot', 0.5, { opacity: 0 })
        },
        resetPage2() {
            TweenMax.set('.page2 .slot', { opacity: 0 })
        },
        outPage2() {
            TweenMax.to('.page2 .slot', 0.5, { opacity: 0 })
        },
        resetPage3() {
            TweenMax.set('.page3 .price-box', { opacity: 0, y: 100 })
            TweenMax.set('.page3 .btn-dealer', { opacity: 0, y: 100 })
        },
        outPage3() {
            TweenMax.to('.page3 .price-box', 0.5, { opacity: 0, y: 100 })
            // TweenMax.to('.page3 .btn-dealer', 0.5, { opacity: 0, y: 100 })
        },
        outPage6() {
            TweenMax.to('.page6 .yuyue-box', 0.5, { y: calcSize(590) })
        },
        resetPage4() {
            $('.page4 img').removeClass('active')
        },
        outPage4() {
            $('.page4 img').removeClass('active')
            this.page4SelectIndex = 0
        },
        resetPage5() {
            TweenMax.set('.page5 .content-0 .logo', { opacity: 0, y: 100 })
            TweenMax.set('.page5 .content-0 .line', { opacity: 0, y: 100 })
            TweenMax.set('.page5 .content-0 .h2', { opacity: 0, y: 100 })
            TweenMax.set('.page5 .content-0 .h5', { opacity: 0, y: 100 })
            TweenMax.set('.page5 .content-1 .logo', { opacity: 0, y: 100 })
            TweenMax.set('.page5 .content-1 .txt', { opacity: 0, y: 100 })
        },
        outPage5() {
            TweenMax.to('.page5 .content-0 .logo', 0.5, { opacity: 0, y: 100 })
            TweenMax.to('.page5 .content-0 .line', 0.5, { opacity: 0, y: 100 })
            TweenMax.to('.page5 .content-0 .h2', 0.5, { opacity: 0, y: 100 })
            TweenMax.to('.page5 .content-0 .h5', 0.5, { opacity: 0, y: 100 })
            TweenMax.to('.page5 .content-1 .logo', 0.5, { opacity: 0, y: 100 })
            TweenMax.to('.page5 .content-1 .txt', 0.5, { opacity: 0, y: 100 })
        },
        menuClick(idx) {
            if (!this.canWheel) return
            if (idx == this.prevPageIndex) return
            this.changePage(idx)
        },
        changePage(pageIdx) {
            if(pageIdx == this.prevPageIndex) return;
            var that = this
            this.canWheel = false
            this.outMenu()
            this.outPage0()
            this.outPage3()
            this.outPage6()
            this.outPage1()
            this.outPage2()
            this.outPage4()
            this.outPage5()
            var list = [
                { page: '.page0', curr: false, pidx: 0 },
                { page: '.page3', curr: false, pidx: 3 },
                { page: '.page6', curr: false, pidx: 6 },
                { page: '.page1', curr: false, pidx: 1 },
                { page: '.page2', curr: false, pidx: 2 },
                { page: '.page4', curr: false, pidx: 4 },
                { page: '.page5', curr: false, pidx: 5 }
            ]
            for (var i = 0; i < list.length; i++) {
                if (list[i].pidx == this.prevPageIndex) {
                    list[i].curr = true
                    break
                }
            }
            var idx = list.findIndex((it) => {
                return it.pidx == pageIdx
            })
            var prevIdx = list.findIndex((it) => {
                return it.pidx == this.prevPageIndex
            })
            this.prevPageIndex = pageIdx

            var addIndex = 2 - prevIdx
            if (addIndex > 0) {
                var pop = list.splice(-addIndex, addIndex)
                for (var i = pop.length - 1; i >= 0; i--) {
                    list.splice(0, 0, pop[i])
                }
            } else {
                var pop = list.splice(0, -addIndex)
                list.push(...pop)
            }

            var width = $(window).width()
            var height = $(height).height()
            var size = 0.5

            var wh = $(window).height()
            var h = $(window).height() * size
            var addH = (wh - h) / 2

            console.log(list)

            var yvalue = -200
            for (var i = 0; i < list.length; i++) {
                var item = list[i]
                if (item.curr) {
                    TweenMax.set(item.page, { scale: 1, zIndex: 30, display: 'block', y: yvalue + 'vh' })
                } else {
                    TweenMax.set(item.page, { scale: 1, zIndex: 3, display: 'block', y: yvalue + 'vh' })
                }
                yvalue += 100
            }
            var yindex = 2
            var addYValue = -40
            for (var i = 0; i < list.length; i++) {
                var item = list[i]
                item.y = -h * yindex + addYValue
                TweenMax.to(item.page, 0.7, { scale: size, y: item.y })
                yindex -= 1
                addYValue += 20
            }
            var nextIndex = list.findIndex((it) => {
                return it.page == '.page' + pageIdx
            })
            var nextItem = list[nextIndex] // 下个页面
            var currItem = list[2] // 当前页面
            var y = currItem.y
            currItem.y = nextItem.y
            nextItem.y = y
            // 切换页面顺序
            list.splice(2, 1)
            if (nextIndex > 2) {
                list.splice(nextIndex - 1, 1)
                list.splice(nextIndex - 1, 0, currItem)
                list.splice(2, 0, nextItem)
            } else {
                list.splice(nextIndex, 1)
                list.splice(nextIndex, 0, currItem)
                list.splice(2, 0, nextItem)
            }

            nextIndex = 2
            // 页面切换完成
            var onCurrPageComplete = function () {
                if (that.isDestroy) return
                for (var i = 0; i < list.length; i++) {
                    var item = list[i]
                    if (i == nextIndex) {
                        TweenMax.set(item.page, { zIndex: 30 })
                    } else {
                        TweenMax.set(item.page, { display: 'none' })
                    }
                }
                if (nextItem.page == '.page0') {
                    that.bindPage0()
                } else if (nextItem.page == '.page3') {
                    that.bindPage3()
                } else if (nextItem.page == '.page6') {
                    that.bindPage6()
                } else if (nextItem.page == '.page1') {
                    that.bindPage1()
                } else if (nextItem.page == '.page2') {
                    that.bindPage2()
                } else if (nextItem.page == '.page4') {
                    that.bindPage4()
                } else if (nextItem.page == '.page5') {
                    that.bindPage5()
                }
            }

            for (var i = 0; i < list.length; i++) {
                var item = list[i]
                TweenMax.to(item.page, 0.7, { y: item.y, delay: 0.7 })
            }

            for (var i = 0; i < list.length; i++) {
                var item = list[i]
                if (i == nextIndex) {
                    TweenMax.to(item.page, 0.7, { zIndex:6, scale: 1, y: 0, delay: 1.4, onComplete: onCurrPageComplete })
                } else {
                    if (i < 2) {
                        TweenMax.to(item.page, 0.7, { y: item.y - addH, delay: 1.4 })
                    } else {
                        TweenMax.to(item.page, 0.7, { y: item.y + addH, delay: 1.4 })
                    }
                }
            }
        },
        bindPage0() {
            var that = this 
            TweenMax.killTweensOf('.page0 .logo')
            TweenMax.killTweensOf('.page0 .texts')
            TweenMax.to('.page0 .logo', 1, { opacity: 1, y: 0 })
            TweenMax.to('.page0 .texts', 1, {
                opacity: 1,
                y: 0,
                delay: 0.5,
                onComplete: () => {
                    that.currStep = 1
                    that.canWheel = true;
                }
            })
        },
        bindPage0Next() {
            var that = this
            var tween = null
            var onUpdate = function () {
                var num = parseInt(tween.progress() * 20)
                num = num < 1 ? 1 : num
                num = num > 20 ? 20 : num
                if (num < 10) {
                    $('.page0 .num_a').html('0')
                    $('.page0 .num_b').html(num)
                } else {
                    $('.page0 .num_a').html((num + '').substr(0, 1))
                    $('.page0 .num_b').html((num + '').substr(1, 1))
                }
            }
            var onComplete = function () {
                that.currStep = 3
                that.canWheel = true
            }
            TweenMax.to('.page0 .logo', 0.5, { opacity: 0, x: -800 })
            TweenMax.to('.page0 .texts', 0.5, { opacity: 0, x: -800, delay: 0.15 })
            TweenMax.to('.page0 .num_a', 0.7, { opacity: 1, delay: 0.2 })
            TweenMax.to('.page0 .num_b', 0.7, { opacity: 1, delay: 0.4 })
            TweenMax.to('.page0 .num_text', 0.7, { opacity: 1, x: 0, delay: 1.4, onComplete: onComplete })
            tween = TweenMax.to('.page0 .num_b', 1.5, { num: 20, onUpdate: onUpdate })
        },
        bindPage0Next2() {
            var that = this
            var onYuyueComplete = function () {
                that.currStep = 5
                that.canWheel = true
            }
            TweenMax.set('.page0', { zIndex: 5 })
            TweenMax.set('.page3', { zIndex: 0, display: 'block', y: 0, x: 0, scale: 1, opacity: 1 })
            TweenMax.set('.page3 .price-box', { opacity: 0, y: calcSize(100) })
            this.prevPageIndex = 3;

            TweenMax.to('.page0 .topbox', 0.7, { top: '-50vh', delay: 0.1 })
            TweenMax.to('.page0 .bottombox', 0.7, { top: '100vh', delay: 0.1 })
            TweenMax.to('.menubox', 0.7, { y: 0, delay: 1 })
            TweenMax.to('.page3 .price-box', 0.7, { opacity: 1, y: 0, delay: 0.5, onComplete: onYuyueComplete })
            $('.menubox .item').removeClass('active')
        },
        bindPage0Next4() {
            var that = this
            var onYuyueComplete = function () {
                that.currStep = 3
                that.canWheel = true
            }
            TweenMax.to('.page0 .price-box', 0.5, { y: 100, opacity: 0 })
            TweenMax.to('.page0 .yuyue-box', 0.7, { y: 0, onComplete: onYuyueComplete })
        },
        bindPage0Next3() {
            var that = this
            var onYuyueComplete = function () {
                that.currStep = 3
                that.canWheel = true
            }
            that.inMenu(0)
            TweenMax.to('.page0 .yuyue-box', 0.7, { y: 0, onComplete: onYuyueComplete })
        },

        bindPage1() {
            var that = this
            var onComplete = function () {
                that.currStep = 9
                that.canWheel = true
                that.inMenu(1)
            }

            for (var i = 0; i <= 2; i++) {
                if (i == 2) {
                    TweenMax.to('.page1 .slot' + i, 0.5, { opacity: 1, delay: i * 0.2, onComplete: onComplete })
                } else {
                    TweenMax.to('.page1 .slot' + i, 0.5, { opacity: 1, delay: i * 0.2 })
                }
            }
        },
        bindPage2() {
            var that = this
            var onComplete = function () {
                that.currStep = 11
                that.canWheel = true
                that.inMenu(2)
            }

            for (var i = 0; i <= 2; i++) {
                if (i == 2) {
                    TweenMax.to('.page2 .slot' + i, 0.7, { opacity: 1, delay: i * 0.2, onComplete: onComplete })
                } else {
                    TweenMax.to('.page2 .slot' + i, 0.7, { opacity: 1, delay: i * 0.2 })
                }
            }
        },
        bindPage3() {
            var that = this
            var onComplete = function () {
                that.currStep = 5
                that.canWheel = true
                that.inMenu(3)
            }

            TweenMax.to('.page3 .price-box', 0.7, { opacity: 1, y: 0, delay: 0 })
            TweenMax.to('.page3 .btn-dealer', 0.7, { opacity: 1, y: 0, delay: 0.2, onComplete: onComplete })
        },
        bindPage6() {
            var that = this
            var onComplete = function () {
                that.currStep = 7
                that.canWheel = true
                that.inMenu(6)
            }
            TweenMax.to('.page6 .yuyue-box', 0.7, { opacity: 1, y: 0, delay: 0, onComplete: onComplete })
        },
        bindPage4() {
            var that = this
            var onComplete = function () {
                that.currStep = 13
                that.canWheel = true
                that.inMenu(4)
            }

            onComplete()
        },
        bindPage5() {
            var that = this
            var onComplete = function () {
                that.currStep = 14
                that.canWheel = true
                that.inMenu(5)
            }

            TweenMax.to('.page5 .content-0 .logo', 0.7, { opacity: 1, y: 0, delay: 0 })
            TweenMax.to('.page5 .content-0 .line', 0.7, { opacity: 1, y: 0, delay: 0.2 })
            TweenMax.to('.page5 .content-0 .h2', 0.7, { opacity: 1, y: 0, delay: 0.4 })
            TweenMax.to('.page5 .content-0 .h5', 0.7, { opacity: 1, y: 0, delay: 0.6 })
            TweenMax.to('.page5 .content-1 .logo', 0.7, { opacity: 1, y: 0, delay: 0.8 })
            TweenMax.to('.page5 .content-1 .txt', 0.7, { opacity: 1, y: 0, delay: 1.0, onComplete: onComplete })
        },
        bindPage4Event() {
            var that = this
            this.page4SelectIndex = 0
            var imageList = []
            $('.image-grid img').each(function (i, el) {
                var idx = parseInt($(el).attr('idx'))
                if (idx >= 0) {
                    var src = $(el).attr('src')
                    imageList.push({
                        idx: idx,
                        src: src,
                        target: el
                    })
                    $(el).click(function () {
                        $('.image-grid img').removeClass('active')
                        $(el).addClass('active')
                        that.page4SelectIndex = idx
                        $('.image-grid .cell-1 .row1 img').attr('src', src)
                    })
                }
            })
            $('.image-grid .btn-next').click(function () {
                that.page4SelectIndex++
                if (that.page4SelectIndex >= 8) {
                    that.page4SelectIndex = 0
                }
                var item = imageList.find((it) => {
                    return it.idx == that.page4SelectIndex
                })
                if (item) {
                    item.target.click()
                }
            })
        },
        bindSwiper() {
            this.swiper_page1_slot0 = new Swiper('.swiper_page1_slot0 .mySwiper', {
                mousewheel: true,
                pagination: {
                    el: '.swiper-pagination'
                },
                on: {
                    slideChangeTransitionStart: function () {
                        console.log('slideChangeTransitionStart')
                    },
                    slideChangeTransitionEnd: function () {
                        var idx = this.activeIndex
                        console.log(idx)
                        for (var i = 0; i <= 1; i++) {
                            var slide = $('.swiper_page1_slot0 .swiper-slide').eq(i)
                            if (i == idx) {
                                TweenMax.to($(slide).find('.h3'), 0.5, { opacity: 1, y: 0, delay: 0 })
                                TweenMax.to($(slide).find('.desc'), 0.5, { opacity: 1, y: 0, delay: 0.2 })
                                TweenMax.to($(slide).find('.close'), 0.5, { opacity: 1, y: 0, delay: 0.4 })
                            } else {
                                TweenMax.to($(slide).find('.h3'), 0.5, { opacity: 0, y: 100 })
                                TweenMax.to($(slide).find('.desc'), 0.5, { opacity: 0, y: 100 })
                                TweenMax.to($(slide).find('.close'), 0.5, { opacity: 0, y: 100 })
                            }
                        }
                    }
                }
            })
            this.swiper_page1_slot1 = new Swiper('.swiper_page1_slot1 .mySwiper', {
                mousewheel: true,
                pagination: {
                    el: '.swiper-pagination'
                },
                on: {
                    slideChangeTransitionEnd: function () {
                        var idx = this.activeIndex
                        console.log(idx)
                        for (var i = 0; i <= 1; i++) {
                            var slide = $('.swiper_page1_slot1 .swiper-slide').eq(i)
                            if (i == idx) {
                                TweenMax.to($(slide).find('.h3'), 0.5, { opacity: 1, y: 0, delay: 0 })
                                TweenMax.to($(slide).find('.desc'), 0.5, { opacity: 1, y: 0, delay: 0.2 })
                                TweenMax.to($(slide).find('.close'), 0.5, { opacity: 1, y: 0, delay: 0.4 })
                            } else {
                                TweenMax.to($(slide).find('.h3'), 0.5, { opacity: 0, y: 100 })
                                TweenMax.to($(slide).find('.desc'), 0.5, { opacity: 0, y: 100 })
                                TweenMax.to($(slide).find('.close'), 0.5, { opacity: 0, y: 100 })
                            }
                        }
                    }
                }
            })
            this.swiper_page1_slot2 = new Swiper('.swiper_page1_slot2 .mySwiper', {
                mousewheel: true,
                pagination: {
                    el: '.swiper-pagination'
                },
                on: {
                    slideChangeTransitionEnd: function () {
                        var idx = this.activeIndex
                        console.log(idx)
                        for (var i = 0; i <= 1; i++) {
                            var slide = $('.swiper_page1_slot2 .swiper-slide').eq(i)
                            if (i == idx) {
                                TweenMax.to($(slide).find('.h3'), 0.5, { opacity: 1, y: 0, delay: 0 })
                                TweenMax.to($(slide).find('.desc'), 0.5, { opacity: 1, y: 0, delay: 0.2 })
                                TweenMax.to($(slide).find('.close'), 0.5, { opacity: 1, y: 0, delay: 0.4 })
                            } else {
                                TweenMax.to($(slide).find('.h3'), 0.5, { opacity: 0, y: 100 })
                                TweenMax.to($(slide).find('.desc'), 0.5, { opacity: 0, y: 100 })
                                TweenMax.to($(slide).find('.close'), 0.5, { opacity: 0, y: 100 })
                            }
                        }
                    }
                }
            })
            this.swiper_page2_slot0 = new Swiper('.swiper_page2_slot0 .mySwiper', {
                mousewheel: true,
                pagination: {
                    el: '.swiper-pagination'
                },
                on: {
                    slideChangeTransitionEnd: function () {
                        var idx = this.activeIndex
                        console.log(idx)
                        for (var i = 0; i <= 2; i++) {
                            var slide = $('.swiper_page2_slot0 .swiper-slide').eq(i)
                            if (i == idx) {
                                TweenMax.to($(slide).find('.h3'), 0.5, { opacity: 1, y: 0, delay: 0 })
                                TweenMax.to($(slide).find('.desc'), 0.5, { opacity: 1, y: 0, delay: 0.2 })
                                TweenMax.to($(slide).find('.close'), 0.5, { opacity: 1, y: 0, delay: 0.4 })
                            } else {
                                TweenMax.to($(slide).find('.h3'), 0.5, { opacity: 0, y: 100 })
                                TweenMax.to($(slide).find('.desc'), 0.5, { opacity: 0, y: 100 })
                                TweenMax.to($(slide).find('.close'), 0.5, { opacity: 0, y: 100 })
                            }
                        }
                    }
                }
            })
            this.swiper_page2_slot1 = new Swiper('.swiper_page2_slot1 .mySwiper', {
                mousewheel: true,
                pagination: {
                    el: '.swiper-pagination'
                },
                on: {
                    slideChangeTransitionEnd: function () {
                        var idx = this.activeIndex
                        console.log(idx)
                        for (var i = 0; i <= 1; i++) {
                            var slide = $('.swiper_page2_slot1 .swiper-slide').eq(i)
                            if (i == idx) {
                                TweenMax.to($(slide).find('.h3'), 0.5, { opacity: 1, y: 0, delay: 0 })
                                TweenMax.to($(slide).find('.desc'), 0.5, { opacity: 1, y: 0, delay: 0.2 })
                                TweenMax.to($(slide).find('.close'), 0.5, { opacity: 1, y: 0, delay: 0.4 })
                            } else {
                                TweenMax.to($(slide).find('.h3'), 0.5, { opacity: 0, y: 100 })
                                TweenMax.to($(slide).find('.desc'), 0.5, { opacity: 0, y: 100 })
                                TweenMax.to($(slide).find('.close'), 0.5, { opacity: 0, y: 100 })
                            }
                        }
                    }
                }
            })
            this.swiper_page2_slot2 = new Swiper('.swiper_page2_slot2 .mySwiper', {
                mousewheel: true,
                pagination: {
                    el: '.swiper-pagination'
                },
                on: {
                    slideChangeTransitionEnd: function () {
                        var idx = this.activeIndex
                        console.log(idx)
                        for (var i = 0; i <= 3; i++) {
                            var slide = $('.swiper_page2_slot2 .swiper-slide').eq(i)
                            if (i == idx) {
                                TweenMax.to($(slide).find('.h3'), 0.5, { opacity: 1, y: 0, delay: 0 })
                                TweenMax.to($(slide).find('.desc'), 0.5, { opacity: 1, y: 0, delay: 0.2 })
                                TweenMax.to($(slide).find('.close'), 0.5, { opacity: 1, y: 0, delay: 0.4 })
                            } else {
                                TweenMax.to($(slide).find('.h3'), 0.5, { opacity: 0, y: 100 })
                                TweenMax.to($(slide).find('.desc'), 0.5, { opacity: 0, y: 100 })
                                TweenMax.to($(slide).find('.close'), 0.5, { opacity: 0, y: 100 })
                            }
                        }
                    }
                }
            })
            this.swiper_page1 = [this.swiper_page1_slot0, this.swiper_page1_slot1, this.swiper_page1_slot2]
            this.swiper_page2 = [this.swiper_page2_slot0, this.swiper_page2_slot1, this.swiper_page2_slot2]
        },
        showPage1Swiper(idx) {
            this.canWheel = false;
            var that = this
            TweenMax.set('.swiper_page1_slot' + idx + ' .swiper-slide .h3', { opacity: 0, y: 100 })
            TweenMax.set('.swiper_page1_slot' + idx + ' .swiper-slide .desc', { opacity: 0, y: 100 })
            TweenMax.set('.swiper_page1_slot' + idx + ' .swiper-slide .close', { opacity: 0, y: 100 })
            TweenMax.set('.swiper_page1_slot' + idx, { opacity: 0, display: 'block' })
            TweenMax.to('.swiper_page1_slot' + idx, 0.5, {
                opacity: 1,
                onComplete: () => {
                    var slide = $('.swiper_page1_slot' + idx + ' .swiper-slide').eq(0)
                    TweenMax.to($(slide).find('.h3'), 0.5, { opacity: 1, y: 0, delay: 0 })
                    TweenMax.to($(slide).find('.desc'), 0.5, { opacity: 1, y: 0, delay: 0.2 })
                    TweenMax.to($(slide).find('.close'), 0.5, { opacity: 1, y: 0, delay: 0.4 })
                }
            })
            setTimeout(() => {
                that.swiper_page1[idx].update(true)
                that.swiper_page1[idx].slideTo(0, 100, false)
            })
        },
        hidePage1Swiper(idx) {
            this.canWheel = true;
            $('.swiper_page1_slot').eq(idx).fadeOut()
        },
        showPage2Swiper(idx) {
            this.canWheel = false;
            var that = this
            TweenMax.set('.swiper_page2_slot' + idx + ' .swiper-slide .h3', { opacity: 0, y: 100 })
            TweenMax.set('.swiper_page2_slot' + idx + ' .swiper-slide .desc', { opacity: 0, y: 100 })
            TweenMax.set('.swiper_page2_slot' + idx + ' .swiper-slide .close', { opacity: 0, y: 100 })
            TweenMax.set('.swiper_page2_slot' + idx, { opacity: 0, display: 'block' })
            TweenMax.to('.swiper_page2_slot' + idx, 0.5, {
                opacity: 1,
                onComplete: () => {
                    var slide = $('.swiper_page2_slot' + idx + ' .swiper-slide').eq(0)
                    TweenMax.to($(slide).find('.h3'), 0.5, { opacity: 1, y: 0, delay: 0 })
                    TweenMax.to($(slide).find('.desc'), 0.5, { opacity: 1, y: 0, delay: 0.2 })
                    TweenMax.to($(slide).find('.close'), 0.5, { opacity: 1, y: 0, delay: 0.4 })
                }
            })
            setTimeout(() => {
                that.swiper_page2[idx].update(true)
                that.swiper_page2[idx].slideTo(0, 100, false)
            })
        },
        hidePage2Swiper(idx) {
            this.canWheel = true;
            $('.swiper_page2_slot').eq(idx).fadeOut()
        },
        toDealerUrl() {
            window.open('https://www.audi.cn/zh/new-dealerprocity.html')
        },
        toGt() {
            this.$router.replace('/indexb')
            try{
                stm_clicki('send', 'event', 'RS', '点击', 'RS 6 Avant GT',1);
            }catch(e){
                
            }
        }
    }
}
</script>

<style scoped lang="scss">
.indexaPage {
    position: relative;
    width: 100%;
    background: #000;
    color: #fff;
    height: 100vh;
    overflow: hidden;
    .page {
        width: 100%;
        height: 100vh;
        background-color: #000;
        position: absolute;
        left: 0;
        top: 0;
        overflow: hidden;
    }
    .page0 {
        z-index: 5;
        background-color: rgba(0, 0, 0, 0);
        .mainbg {
            display: none;
            width: 100%;
            height: 100%;
            background: url(../assets/indexa/main_bg.jpg) no-repeat center center;
            background-size: cover;
            position: absolute;
            z-index: 1;
            .price-box {
                padding-top: 132px;
                display: flex;
                flex-direction: row;
                justify-content: center;
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                z-index: 3;
                .price {
                    font-size: 108px;
                    line-height: 1;
                    font-family: 'AudiTypeGBWideBold';
                    background: linear-gradient(180deg, rgba(8, 8, 8, 1), rgba(5, 5, 5, 0.3));
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
                .price_texts {
                    color: #000;
                    padding-left: 20px;
                    .price0 {
                        font-size: 32px;
                        line-height: 1;
                        padding-top: 14px;
                    }
                    .price1 {
                        font-size: 50px;
                        line-height: 1;
                        font-family: 'audi_wide_light_4.03';
                    }
                }
            }
            .yuyue-box {
                width: 100%;
                height: 583px;
                position: absolute;
                left: 0;
                bottom: 0;
                z-index: 4;
                transform: translateY(-590px);
            }
        }
        .topbox {
            width: 100%;
            height: 50vh;
            overflow: hidden;
            position: absolute;
            left: 0;
            top: 0;
            .cullcon {
                width: 100%;
                height: 100vh;
                overflow: hidden;
                position: absolute;
                left: 0;
                top: 0;
            }
        }
        .bottombox {
            width: 100%;
            height: 50vh;
            overflow: hidden;
            position: absolute;
            left: 0;
            top: 50vh;
            .cullcon {
                width: 100%;
                height: 100vh;
                overflow: hidden;
                position: absolute;
                left: 0;
                top: -50vh;
            }
        }
        .bg {
            width: 100%;
            height: 100%;
            background: #000 url(../assets/indexa/page0_bg.jpg) no-repeat center center;
            background-size: cover;
            position: absolute;
            z-index: 4;
        }
        .con {
            width: 100%;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            display: flex;
            flex-direction: column;
            justify-content: center;
            z-index: 7;
            .logo {
                background: url(../assets/indexa/logo.png) no-repeat center center;
                background-size: contain;
                width: 687px;
                height: 48px;
                margin: 0 auto;
                opacity: 0;
            }
            .texts {
                margin-top: 60px;
                z-index: 3;
                text-align: center;
                font-size: 64px;
                line-height: 77px;
                font-family: 'audi-zh-medium';
                opacity: 0;
            }
        }
        .mask {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 10;
            background: rgba(0, 0, 0, 1);
            opacity: 0;
        }
        .num_a {
            width: 508px;
            height: 732px;
            position: absolute;
            left: 565px;
            top: 174px;
            font-size: 600px;
            line-height: 732px;
            z-index: 30;
            font-family: 'audi_extended_bold_4.03';
            background: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(153, 153, 153, 0.2));
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            opacity: 0;
        }
        .num_b {
            width: 288px;
            height: 415px;
            position: absolute;
            left: 1053px;
            top: 257px;
            font-size: 340px;
            line-height: 415px;
            z-index: 30;
            font-family: 'audi_extended_bold_4.03';
            background: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(153, 153, 153, 0.2));
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            opacity: 0;
        }
        .num_text {
            position: absolute;
            z-index: 40;
            width: 500px;
            left: 1073px;
            top: 632px;
            opacity: 0;
            .txt0 {
                font-size: 40px;
                line-height: 49px;
                font-family: 'DFPKingGothicGBMedium';
                .en {
                    font-family: 'audi_bold_4.03';
                }
            }
            .txt1 {
                margin-top: 20px;
                font-size: 26px;
                line-height: 32px;
                color: #d70530;
                .en {
                    font-family: 'audi_normal_4.03';
                }
            }
        }
    }

    .menubox {
        width: 1171px;
        height: 85px;
        position: fixed;
        left: 375px;
        top: 18px;
        z-index: 100;
        transform: translateY(-110px);
        .menus {
            width: 1114px;
            top: 85px;
            background: url(../assets/indexa/menu_bg.png) no-repeat left top;
            background-size: 100% 84px;
            position: absolute;
            left: 0;
            top: 0;
            display: flex;
            flex-direction: row;
            justify-content: center;
            .item {
                width: 184px;
                height: 85px;
                font-size: 18px;
                line-height: 84px;
                cursor: pointer;
                text-align: center;
                &.active {
                    background: url(../assets/indexa/menu_item_bg.png) no-repeat center center;
                    background-size: 100% 100%;
                }
                &:hover {
                    background: url(../assets/indexa/menu_item_bg.png) no-repeat center center;
                    background-size: 100% 100%;
                }
            }
        }
        .btn-yuyue {
            width: 184px;
            top: 53px;
            background: url(../assets/indexa/menu_yuyue.png) no-repeat left top;
            background-size: contain;
            position: absolute;
            right: 0;
            top: 16px;
            z-index: 3;
            font-size: 18px;
            text-align: center;
            line-height: 53px;
            cursor: pointer;
        }
    }

    .page1 {
        display: none;
        z-index: 3;
        .bg {
            width: 100%;
            height: 100%;
            background: url(../assets/indexa/page1_bg.jpg) no-repeat center center;
            background-size: cover;
        }
        .slotbox {
            position: absolute;
            width: 100%;
            height: 100%;
            z-index: 3;
            display: flex;
            flex-direction: row;
            justify-content: center;
            left: 0;
            top: 0;
            .slot {
                position: relative;
                width: 33.34%;
                background: linear-gradient(270deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.6));
                height: 100%;

                transition: 0.5s all;
                &:hover {
                    background: linear-gradient(270deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
                    .txt {
                        color: #fff;
                    }
                }

                .number {
                    font-size: 200px;
                    line-height: 244px;
                    margin-left: 87px;
                    margin-top: 135px;
                    background: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(153, 153, 153, 0.2));
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    font-family: 'audi_extended_bold_4.03';
                }
                .txt {
                    font-size: 36px;
                    line-height: 43px;
                    margin-left: 87px;
                    color: #acacac;
                    transition: 0.5s all;
                }
                .arrow {
                    width: 60px;
                    height: 60px;
                    position: absolute;
                    left: 88px;
                    bottom: 156px;
                    background: url(../assets/indexa/arrow.png) no-repeat center center;
                    background-size: contain;
                    cursor: pointer;
                }
            }
        }
    }

    .page2 {
        display: none;
        z-index: 4;
        .bg {
            width: 100%;
            height: 100%;
            background: url(../assets/indexa/page2_bg.jpg) no-repeat center center;
            background-size: cover;
        }
        .slotbox {
            position: absolute;
            width: 100%;
            height: 100%;
            z-index: 3;
            display: flex;
            flex-direction: row;
            justify-content: center;
            left: 0;
            top: 0;
            .slot {
                position: relative;
                width: 33.34%;
                background: linear-gradient(270deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.6));
                height: 100%;
                transition: 0.5s all;
                &:hover {
                    background: linear-gradient(270deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
                    .txt {
                        color: #fff;
                    }
                }

                .number {
                    font-size: 200px;
                    line-height: 244px;
                    margin-left: 87px;
                    margin-top: 135px;
                    background: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(153, 153, 153, 0.2));
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    font-family: 'audi_extended_bold_4.03';
                }
                .txt {
                    font-size: 36px;
                    line-height: 43px;
                    margin-left: 87px;
                    color: #acacac;
                    transition: 0.5s all;
                    .en {
                        font-family: 'audi_normal_4.03';
                    }
                }
                .arrow {
                    width: 60px;
                    height: 60px;
                    position: absolute;
                    left: 88px;
                    bottom: 156px;
                    background: url(../assets/indexa/arrow.png) no-repeat center center;
                    background-size: contain;
                    cursor: pointer;
                }
            }
        }
    }

    .page3 {
        display: none;
        z-index: 0;
        .bg {
            width: 100%;
            height: 100%;
            background: url(../assets/indexa/page3_bg.jpg) no-repeat center center;
            background-size: cover;
        }
        .price-box {
            padding-top: 256px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            z-index: 3;
            .price {
                font-size: 108px;
                line-height: 1;
                font-family: 'AudiTypeGBWideBold';
                background: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.1));
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
            }
            .texts {
                padding-left: 20px;
                .txt0 {
                    font-size: 32px;
                    line-height: 1;
                    padding-top: 14px;
                }
                .txt1 {
                    font-size: 50px;
                    line-height: 1;
                    font-family: 'audi_wide_light_4.03';
                }
            }
        }
        .btn-dealer {
            width: 168px;
            height: 49px;
            position: absolute;
            top: 408px;
            left: 878px;
            border: 1px solid #fff;
            border-radius: 0;
            text-align: center;
            line-height: 49px;
            font-size: 20px;
            cursor: pointer;
        }
    }

    .page4 {
        display: none;
        z-index: 6;
        background-color: #000;
        .image-grid {
            position: absolute;
            left: 0;
            top: 103px;
            right: 0;
            bottom: 0;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            .cell-0 {
                width: 324px;
                height: 100%;
                .img0box {
                    width: 100%;
                    height: 50%;
                    overflow: hidden;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        transform: scale(1.1);
                        transition: all 0.5s;
                        opacity: 0.3;
                        &:hover,
                        &.active {
                            transform: scale(1);
                            opacity: 1;
                        }
                    }
                }
                .img1box {
                    width: 100%;
                    height: 50%;
                    overflow: hidden;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        transform: scale(1.1);
                        transition: all 0.5s;
                        opacity: 0.3;
                        &:hover,
                        &.active {
                            transform: scale(1);
                            opacity: 1;
                        }
                    }
                }
            }
            .cell-1 {
                width: 1272px;
                height: 100%;
                display: flex;
                flex-direction: column;
                .row0 {
                    width: 100%;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    height: 125px;
                    flex-shrink: 0;
                    .img0box {
                        width: 50%;
                        height: 100%;
                        overflow: hidden;
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            transform: scale(1.1);
                            transform: scale(1.1);
                            transition: all 0.5s;
                            opacity: 0.3;
                            &:hover,
                            &.active {
                                transform: scale(1);
                                opacity: 1;
                            }
                        }
                    }
                    .img1box {
                        width: 50%;
                        height: 100%;
                        overflow: hidden;
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            transform: scale(1.1);
                            transition: all 0.5s;
                            opacity: 0.3;
                            &:hover,
                            &.active {
                                transform: scale(1);
                                opacity: 1;
                            }
                        }
                    }
                }
                .row1 {
                    width: 100%;
                    height: calc(100% - 250px);
                    .img0box {
                        width: 100%;
                        height: 100%;
                        overflow: hidden;
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                    }
                }
                .row2 {
                    width: 100%;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    height: 125px;
                    flex-shrink: 0;
                    .img0box {
                        width: 50%;
                        height: 100%;
                        overflow: hidden;
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            transform: scale(1.1);
                            transition: all 0.5s;
                            opacity: 0.3;
                            &:hover,
                            &.active {
                                transform: scale(1);
                                opacity: 1;
                            }
                        }
                    }
                    .img1box {
                        width: 50%;
                        height: 100%;
                        overflow: hidden;
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            transform: scale(1.1);
                            transition: all 0.5s;
                            opacity: 0.3;
                            &:hover,
                            &.active {
                                transform: scale(1);
                                opacity: 1;
                            }
                        }
                    }
                }
            }
            .cell-2 {
                width: 324px;
                height: 100%;
                .img0box {
                    width: 100%;
                    height: 50%;
                    overflow: hidden;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        transform: scale(1.1);
                        transition: all 0.5s;
                        opacity: 0.3;
                        &:hover,
                        &.active {
                            transform: scale(1);
                            opacity: 1;
                        }
                    }
                }
                .row1 {
                    width: 100%;
                    height: 50%;
                    overflow: hidden;
                    display: flex;
                    flex-direction: column;
                    .img1box {
                        width: 100%;
                        height: 100%;
                        overflow: hidden;
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            transform: scale(1.1);
                            transition: all 0.5s;
                            opacity: 0.3;
                            &:hover,
                            &.active {
                                transform: scale(1);
                                opacity: 1;
                            }
                        }
                    }
                    .btn-next {
                        width: 100%;
                        height: 127px;
                        background-color: #7c001a;
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: center;
                        flex-shrink: 0;
                        cursor: pointer;
                        span {
                            font-size: 18px;
                            line-height: 1.2;
                            background: url(../assets/indexa/page4_arrow.png) no-repeat right center;
                            background-size: auto 20px;
                            padding-right: 25px;
                        }
                    }
                }
            }
        }
    }

    .page5 {
        display: none;
        z-index: 7;
        background-color: #000;
        .content-0 {
            width: 100%;
            height: 58%;
            position: relative;
            left: 0;
            top: 0;
            .bg {
                width: 100%;
                height: 100%;
                background: url(../assets/indexa/page5_bg.jpg) no-repeat left center;
                background-size: cover;
            }
            .con {
                position: absolute;
                left: 811px;
                top: 50%;
                transform: translateY(-50%);
                z-index: 2;
                width: 1109px;
                .logo {
                    width: 412px;
                    height: 48px;
                    background: url(../assets/indexa/logo4.png) no-repeat center center;
                    background-size: contain;
                }
                .line {
                    width: 100%;
                    height: 2px;
                    background: url(../assets/indexa/page5_line.png) no-repeat left center;
                    background-size: auto 100%;
                    margin-top: 30px;
                    margin-bottom: 30px;
                }
                .h2 {
                    font-size: 64px;
                    line-height: 1;
                    font-family: 'DFPKingGothicGBMedium';
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    cursor: pointer;
                    .after {
                        content: ' ';
                        background: url(../assets/indexa/arrow.png) no-repeat right center;
                        background-size: contain;
                        width: 60px;
                        height: 60px;
                        margin-left: 100px;
                    }
                }
                .h5 {
                    margin-top: 20px;
                    font-size: 24px;
                    line-height: 1;
                }
            }
        }
        .content-1 {
            width: 100%;
            height: 42%;
            position: relative;
            left: 0;
            top: 0;
            .con {
                position: absolute;
                left: 0%;
                top: 50%;
                transform: translateX(0%) translateY(-50%);
                z-index: 2;
                width: 100%;
                text-align: center;
                .logo {
                    width: 131px;
                    height: 48px;
                    background: url(../assets/indexa/logo3.png) no-repeat center center;
                    background-size: contain;
                    display: block;
                    margin: 0 auto;
                }
                .txt {
                    margin-top: 45px;
                    font-size: 24px;
                    line-height: 1.3;
                    color: #9d9d9d;
                }
            }
        }
    }

    .swiperbox {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 1000;
        background-color: #000;
        overflow: hidden;

        .close {
            width: 40px;
            height: 40px;
            background: url(../assets/indexa/close.svg) no-repeat center center;
            background-size: contain;
            cursor: pointer;
            position: absolute;
            top: 597px;
            left: 118px;
            &.close1 {
                top: auto;
                bottom: 84px;
            }
            &.close2 {
                top: auto;
                bottom: 84px;
                left: auto;
                right: 90px;
            }
        }
        .imgbox {
            width: 100%;
            height: 100%;
            display: block;
            .img {
                width: 100%;
                height: 100%;
                display: block;
                object-fit: cover;
            }
        }
        .textbox0 {
            position: absolute;
            left: 120px;
            top: 315px;
            position: absolute;
            width: 1000px;
            z-index: 3;
            .h3 {
                font-size: 48px;
                line-height: 58px;
                .en {
                    font-family: 'audi_bold_4.03';
                }
            }
            .desc {
                margin-top: 35px;
                font-size: 24px;
                line-height: 36px;
                .en {
                    font-family: 'audi_normal_4.03';
                }
            }
            &.textbox1 {
                top: auto;
                bottom: 220px;
            }
            &.textbox2 {
                top: auto;
                bottom: 220px;
                left: auto;
                right: 93px;
                text-align: right;
            }
        }
    }
    .page6 {
        z-index: 0;
        display: none;
        .bg {
            width: 100%;
            height: 100%;
            background: url(../assets/indexa/main_bg.jpg) no-repeat center center;
            background-size: cover;
        }
        .yuyue-box {
            width: 100%;
            height: 583px;
            position: absolute;
            left: 0;
            bottom: 0;
            z-index: 4;
            transform: translateY(-590px);
        }
    }
}
</style>
<style>
.pagination-type-0 {
    bottom: 0px !important;
    height: 80px !important;
}
.pagination-type-0 .swiper-pagination-bullet {
    width: 25px !important;
    height: 16px !important;
    background: url(../assets/indexa/buller_0.png) no-repeat !important;
    background-size: contain !important;
    margin: 0 !important;
    padding: 0 !important;
    border-radius: 0 !important;
    opacity: 1;
}
.pagination-type-0 .swiper-pagination-bullet-active {
    background: url(../assets/indexa/buller_1.png) no-repeat !important;
    background-size: contain !important;
}
</style>
